<template>
  <ul v-if="prevLocation || nextLocation">
    <li v-if="prevLocation" class="prev">
      <router-link :to="route(prevLocation)">
        <SvgIcon icon="arrow-left" />
        <span>{{ prevLocation.title }}</span>
      </router-link>
    </li>
    <li v-if="nextLocation" class="next">
      <router-link :to="route(nextLocation)">
        <span>{{ nextLocation.title }}</span>
        <SvgIcon icon="arrow-right" />
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'LocationOverlayNavigation',
  props: ['location'],
  components: { SvgIcon },
  computed: {
    ...mapGetters(['locations']),
    indexInLocations() {
      return this.locations.indexOf(this.location)
    },
    prevLocation() {
      return this.locations[this.indexInLocations - 1]
    },
    nextLocation() {
      return this.locations[this.indexInLocations + 1]
    }
  }
}
</script>

<style scoped>
ul {
  @mixin type-smaller;
  display: flex;
  jsutify-content: space-between;
  width: 100%;
}
li {
  display: flex;
  align-items: center;
  /* flex: 1 0 50%; */
  flex: 1 1 auto;
  min-width: 25%;
  overflow: hidden;
  &:only-child {
    padding: 0;
  }
}
a {
  display: flex;
  align-items: center;
  width: 100%;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
}
span {
  @mixin truncate-ellipsis;
}
.prev a {
  padding-right: 1.5em;
  text-align: left;
  svg {
    margin-right: 1.5em;
  }
}
.next a {
  padding-left: 1.5em;
  justify-content: flex-end;
  text-align: right;
}
/deep/ {
  svg {
    flex: 0 0 calc(var(--content-indent) - 0.5em);
  }
  .prev svg {
    margin-right: 0.5em;
  }
  .next svg {
    margin-left: 0.5em;
  }
}
</style>
